var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block lg:block mr-2"},[_c('div',{staticClass:"text-xs print:text-lg text-gray-500 print:text-black lg:leading-none"},[_vm._v(" "+_vm._s(_vm.number)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }